import { render, staticRenderFns } from "./CustomDatalist.vue?vue&type=template&id=2a267b6c"
import script from "./CustomDatalist.vue?vue&type=script&lang=js"
export * from "./CustomDatalist.vue?vue&type=script&lang=js"
import style0 from "./CustomDatalist.vue?vue&type=style&index=0&id=2a267b6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports